import { useEffect } from 'react';
import Cookies from 'js-cookie';
import styles from './SignupFeaturesSection.module.scss';
import { ChatGPTLogo } from 'src/images/logos/chat-gpt';
import { AnthropicLogo } from 'src/images/logos/anthropic-logo';
import { Icon } from 'src/components/Icon';
import { CheckMarkIcon } from 'src/v2/pages/auth/components/SignupFeaturesSection/CheckMarkIcon';
import { MetaLogo } from 'src/images/logos/meta-logo';
import { DEFAULT_NINJATECH_PRICING_LINK } from 'src/constants/externalLinks';
import userProfilePicture from 'src/images/login/userProfilePicture.png';
import { getReferralId } from 'src/utils';
import {
  SN_REFERRAL_CODE_COOKIE_NAME,
  SUPER_PROJECT_NAME,
} from 'src/constants';
import { env } from 'src/env';
import { useFeatureFlagEnabled } from 'posthog-js/react';

export const FEATURES_LIST_V2_CREDITS = [
  {
    title: `${SUPER_PROJECT_NAME} autonomous AI capabilities available`,
    icon: <CheckMarkIcon width={20} height={20} />,
  },
  {
    title: `Free ${SUPER_PROJECT_NAME} credits to start`,
    icon: <CheckMarkIcon width={20} height={20} />,
  },
  {
    title: 'Premium AI models from OpenAI, Anthropic, Google and more',
    icon: <CheckMarkIcon width={20} height={20} />,
  },
  {
    title: 'Intelligent infinite context',
    icon: <CheckMarkIcon width={20} height={20} />,
  },
  {
    title: 'VS Code, HTML, Text and Image Editors included',
    icon: <CheckMarkIcon width={20} height={20} />,
  },
  {
    title: 'AI Actions Time Machine to undo any AI mistakes seamlessly',
    icon: <CheckMarkIcon width={20} height={20} />,
  },
];

export const FEATURES_LIST = [
  {
    title: `${SUPER_PROJECT_NAME} autonomous AI capabilities available`,
    icon: <CheckMarkIcon width={20} height={20} />,
  },
  {
    title: `Free ${SUPER_PROJECT_NAME} monthly tasks to start`,
    icon: <CheckMarkIcon width={20} height={20} />,
  },
  {
    title: `40+ Premium AI models from OpenAI, Anthropic, Google, Amazon and more`,
    icon: <CheckMarkIcon width={20} height={20} />,
  },
  {
    title: '10M+ Token context',
    icon: <CheckMarkIcon width={20} height={20} />,
  },
  {
    title: 'VS Code, HTML, Text and Image Editors included',
    icon: <CheckMarkIcon width={20} height={20} />,
  },
  {
    title:
      'AI Actions Time Machine to undo any AI mistakes seamlessly (coming soon)',
    icon: <CheckMarkIcon width={20} height={20} />,
  },
];

export const MODELS_LIST = [
  {
    title: 'Open AI',
    icon: <ChatGPTLogo color={'black'} />,
  },
  {
    title: 'Anthropic',
    icon: <AnthropicLogo color={'#181818'} />,
  },
  {
    title: 'Google',
    icon: <Icon type="googleGeminiProLogo" size={20} />,
  },
  {
    title: 'Meta',
    icon: <MetaLogo />,
  },
];

export const SignupFeaturesSection = () => {
  const referralId = getReferralId();
  const isCreditBasedPaymentEnabled = useFeatureFlagEnabled(
    'credit-based-system',
  );

  useEffect(() => {
    if (referralId) {
      const cookieDomain = env.REACT_APP_COOKIE_DOMAIN;
      console.log('[SignupFeaturesSection] Cookie domain:', {
        cookieDomain,
        hasCookieDomain: !!cookieDomain,
      });

      if (cookieDomain) {
        console.log('[SignupFeaturesSection] Setting referral cookie', {
          cookieName: SN_REFERRAL_CODE_COOKIE_NAME,
          referralId,
          domain: cookieDomain,
          expires: 365,
        });

        Cookies.set(SN_REFERRAL_CODE_COOKIE_NAME, referralId, {
          domain: cookieDomain,
          expires: 365,
          secure: true,
          sameSite: 'Lax',
        });

        console.log('[SignupFeaturesSection] Cookie set successfully');
      }
    }
  }, [referralId]);

  return (
    <div className={styles.root}>
      {!!referralId && (
        <>
          <div className={styles.referralHeaderWelcome}>
            <img
              className={styles.userProfileImage}
              src={userProfilePicture}
              alt="UserProfilePicture"
            />
            <span>You’ve been personally invited to try SuperNinja!</span>
          </div>
          <p className={styles.referralDescription}>
            Claim Your Rewards. Subscribe Now!
          </p>
        </>
      )}
      <div>
        <div className={styles.mainTitle}>
          Meet SuperNinja – Your complete AI workforce
        </div>
        <p className={styles.description}>
          AI Agent with its own computer - Chat, Research, Build and Deploy
        </p>
      </div>
      <div className={styles.featuresSection}>
        <ul className={styles.featuresList}>
          {(isCreditBasedPaymentEnabled
            ? FEATURES_LIST_V2_CREDITS
            : FEATURES_LIST
          ).map((item, index) => (
            <li className={styles.featureRow} key={index}>
              <span className={styles.checkMark}>{item.icon}</span>
              <span>{item.title}</span>
            </li>
          ))}
        </ul>
      </div>

      <a
        className={styles.pricingLink}
        href={DEFAULT_NINJATECH_PRICING_LINK}
        target="_blank"
        rel="noreferrer"
      >
        Explore Our Pricing Plans
      </a>
    </div>
  );
};
